import api from './axiosInstance';
export const getAll = (params) => api.get('/accessories', { params });
export const getById = (id) => api.get(`/accessories/${id}`);
export const create = (data) => api.post('/accessories', data);
export const update = (id, data) => api.put(`/accessories/${id}`, data);
export const remove = (id) => api.delete(`/accessories/${id}`);
export const batchRemove = (ids) => api.post('/accessories/batch-delete', { ids });
